<template>
    <v-dialog
        v-model="isDialogOpen"
        persistent
        max-width="300">
        <v-card>
            <v-card-text>
                <h1 class="title-dialog-two-options">
                    {{title}}
                </h1>
                <p class="txt-dialog-two-options">
                    {{ txtOne }}<strong>{{txtBold}}</strong>{{txtTwo}}
                </p>
            </v-card-text>
            <v-card-actions >
                <v-btn
                    class="btn-dialog-two-options"
                    color="#707070"
                    @click="isDialogOpen = false">
                    No, Cancelar
                </v-btn>
                <v-btn
                    class="btn-dialog-two-options"
                    color="#FF5700"
                    @click="okBtn">
                    {{txtBtn}}
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
export default {
  name: 'CommerciaVueDiaogTwoOptions',
  emits: ['okBtn'],
  props: {
    title: String,
    txtBtn: String,
    txtOne: String,
    txtTwo: String,
    txtBold: String
  },
  data () {
    return {
      isDialogOpen: false
    }
  },
  methods: {
    open () {
      this.isDialogOpen = true
    },
    okBtn () {
      this.isDialogOpen = false
      this.$emit('okBtn')
    }
  }
}
</script>
<style scoped>
    .title-dialog-two-options{
        width: 100%;
        text-align: center;
        font-size: 16px;
        font-weight: bold;
        margin-bottom: 10px;
    }
    .txt-dialog-two-options{
        width: 100%;
        text-align: center;
        font-size: 16px;
    }
    .btn-dialog-two-options{
        width: 49%;
    }
</style>
